<div class="wrapper">
  <div class="heading text-type-2 mb-[20px] flex flex-row justify-between items-center">
    <div class="title text-type-2">Materials for {{ bidItemName }}</div>
    <mat-icon (click)="close()">close</mat-icon>
  </div>

  <!-- Quantity (view-only) -->
  <app-view-field
    [label]="'Quantity'"
    [uom]="data?.uom || ''"
    [value]="'' + lineItemQuantity"
    class="mb-[30px]"
  />

  <!-- Material Set Dropdown -->
  <app-dropdown
    [options]="materialSetOptions"
    [parentFormGroup]="selectedMaterialSetForm"
    [sentenceCase]="true"
    class="mb-[20px]"
    controlName="materialSetId"
    label="Material set"
  />

  <!-- Materials Accordions -->
  @if (selectedMaterialSet) {
    <div class="materials-section">
      @for (msm of selectedMaterialSet.bid_item_material_set_material; track msm.id) {
        <div
          [class.is-expanded]="expandedMaterialId === msm.material?.id"
          class="material-accordion"
        >
          <div
            (click)="toggleMaterial(msm.material?.id)"
            class="material-header flex justify-between items-center cursor-pointer"
          >
            <div class="material-name text-type-8">{{ msm.material?.name | sentenceCase }}</div>
            <mat-icon
              [svgIcon]="expandedMaterialId === msm.material?.id ? 'chevron-up' : 'chevron-down'"
              class="chevron-icon"
            />
          </div>
          @if (expandedMaterialId === msm.material?.id && materialForms[msm.material?.id]) {
            <div class="material-content" [formGroup]="materialForms[msm.material?.id]">
              <app-number-input
                [isDecimalAllowed]="true"
                [decimalPlaces]="5"
                [maxLength]="24"
                [parentFormGroup]="materialForms[msm.material?.id]"
                [hint]="'Conversion factor: ' + msm.conversion_factor"
                controlName="quantity"
                [label]="'Install QTY (' + (msm.material?.uom || '') + ')'"
              />
            </div>
          }
        </div>
      }
    </div>
  }

  <!-- Done Button -->
  <div class="action-section mt-[40px]">
    <app-primary-button
      (handleClick)="done()"
      [isDisabled]="!selectedMaterialSet"
      class="w-full"
    >
      Done
    </app-primary-button>
  </div>
</div>
